/**
 * components/progressMeter.tsx
 * Single-value progress bar (rounded track + tone fill). Used by the sidebar
 * AI-credits meter and the per-field extraction-confidence bars. `pct` is 0–100.
 */
import React from 'react';
import { View } from 'react-native';
import { useTheme } from '../context/themeContext';
import { web } from '../utils/web';
import { toneColors, type Tone } from '../theme/tone';

export interface ProgressMeterProps {
  pct: number;
  tone?: Tone;
  height?: number;
  /** Track color override (defaults to paper3). */
  trackColor?: string;
}

export default function ProgressMeter({ pct, tone = 'accent', height = 5, trackColor }: ProgressMeterProps) {
  const { theme } = useTheme();
  const { colors, radii } = theme;
  const clamped = Math.max(0, Math.min(100, pct));
  return (
    <View
      style={{
        height,
        borderRadius: radii.pill,
        backgroundColor: trackColor ?? colors.paper3,
        overflow: 'hidden',
      }}
    >
      <View style={[{ height, width: `${clamped}%`, borderRadius: radii.pill, backgroundColor: toneColors(colors, tone).fg }, web({ transition: 'width 700ms cubic-bezier(.2,.7,.2,1)' })]} />
    </View>
  );
}
